import React, { Component } from 'react';
import { connect, useSelector } from 'react-redux';
import { OrderedMap, Map, List } from 'immutable';
import { generateDisplayName, generateInformalDisplayName } from '../../Utils/Person';
import { getProfilePlanning } from '../../Actions/ProfilePlanning';
import { NavLink, Switch, Route } from 'react-router-dom';
import SingeClientPlanning from './SingleClientPlanning';
import SingleClientTeamContact from './SingleClientTeamContact';
import SingleClientDocuments from './SingleClientDocuments';
import { getPortalAddresses } from '../../Actions/PortalAddresses';
import { loadFreelancersInClientTeam } from '../../Actions/Freelancers';
import PdfService from '../../Service/PdfService';
import { apiUrl, apiUrlServer } from '../../Service/EndpointService';
import './Styles/SingleClient.css';
import { TheReadBookButton } from '../TheRedBook';
import authenticationService from '@zorgconnect/shared-portal/Modules/Authentication/Service';

const mapStateToProps = (state) => ({
    // clients: state.getIn(['clients','collection'], OrderedMap()),
    client: state.getIn(['clients','single'], Map()),
    profileplanning: state.getIn(['profileplanning','collection'], OrderedMap()),
    freelancers: state.getIn(['freelancers','collection'], OrderedMap()),
    clientportal: state.getIn(['users','single','clientportal', 0], Map()),
    user: state.getIn(['users','single'], Map())
})

const mapDispatchToProps = (dispatch) => ({
    getProfilePlanning: (params) => dispatch(getProfilePlanning(params)),
    getPortalAddresses: (clientid) => dispatch(getPortalAddresses(clientid)),
    loadFreelancersInClientTeam: () => dispatch(loadFreelancersInClientTeam())
})

class SingleClient extends Component {

    componentDidMount() {
        
        let { client } = this.props;
        let { getClients, getProfilePlanning, getPortalAddresses, loadFreelancersInClientTeam } = this.props;
        
        getProfilePlanning && getProfilePlanning();
        loadFreelancersInClientTeam && loadFreelancersInClientTeam();

        
    }

    componentDidUpdate(prevProps) {

        let { getPortalAddresses } = this.props;

        if(prevProps.client != this.props.client) {
            getPortalAddresses && getPortalAddresses(this.props.client.get('id'));
        }
    }

    render() {

        let { user, clientportal, profileplanning, client, match: { path, params: { start, end } }, freelancers } = this.props;

        // let client = clients.get(clientid);

        if(!client) {
            return <data />
        }

        profileplanning = profileplanning.filter(x => !x.get('isDeleted'));
        profileplanning = profileplanning.filter(x => x.get('clientid') == client.get('id'));

        console.log("SingleClient props", this.props);
 
        let canseedocument = clientportal.get('canseedocuments');
        let canseeredbook = clientportal.get('canseeredbook');

        return <div className="card single-client">
        
            <div className="card-header">
                <h1>{client.get('gender') == 'M' ? 'Dhr.' : 'Mw.'} {generateDisplayName(client)}</h1>

            </div>

            <div className="card-navigation">

                <NavLink to={`/`} exact activeClassName="selected">Weekplanning</NavLink>
                <NavLink to={`/teamcontact`} activeClassName="selected">Teamcontact</NavLink>
                { canseedocument && <NavLink to={`/documents`} activeClassName="selected">Documenten</NavLink> || ""}
            
            </div>

            <div className="card-body client-view">

                <div className="client-view-side">
                    <h2>Client gegevens:</h2>
                    <div>
                        <strong>Kenmerk:</strong> {client.get('id')}<br />
                        <strong>Voorletters:</strong> {client.get('initials')}<br />
                        <strong>Achternaam:</strong> {client.get('lastname')}<br />
                        <strong>Geboortedatum:</strong> {client.get('dateofbirthstring')}<br />
                        <strong>BSN:</strong> {client.get('bsn')}
                    </div>
                    <div>&nbsp;</div>
                    { canseeredbook && <TheReadBookButton user={user} clientportal={clientportal} client={client}  /> || <div /> }
                    <h2>Zorgadres:</h2>
                    <div>
                        {client.getIn(['address','street'])} {client.getIn(['address','number'])}<br />
                        {client.getIn(['address','postalcode'])} {client.getIn(['address','location'])}
                    </div>
                    <h2>Contact</h2>
                    <div>
                        <ul>
                            {(() => {
                                let contactLists = [];

                                if (client.get('phonenumbers')){
                                    client.get('phonenumbers').forEach((phonenumber) => {
                                        let numberInfo = undefined;
                                        if (phonenumber.get('type') && phonenumber.get('type') != ''){
                                            numberInfo = ` (${phonenumber.get('type')})`;
                                        }
                                        contactLists.push((
                                            <li key={phonenumber.get('number')}>
                                                <i className="zmdi zmdi-phone"></i>
                                                {phonenumber.get('number')}{numberInfo}
                                            </li>
                                        ));
                                    });
                                }
                        
                                if (client.get('email')){
                                    contactLists.push((
                                        <li key={client.get('email')}>
                                            <i className="zmdi zmdi-email"></i>
                                            {client.get('email')}
                                        </li>
                                    ));
                                }

                                return contactLists;

                            })()}
                        </ul>
                    </div>
                    <h2>Teamleden</h2>
                    <div>
                        {freelancers.map((freelancer, freelancerid) => {

                            let aanhef = 'Mw.';
                            if(freelancer.get('gender') == 'M' || freelancer.get('gender') == 'm') {
                                aanhef = 'Dhr.';
                            }

                            return <React.Fragment key={freelancerid}>
                                {aanhef} {generateDisplayName(freelancer)} ({freelancerid})<br />
                                
                            </React.Fragment>
                            
                        }).toList()}
                        <DownloadTeamMembersButton client={client} freelancers={freelancers} clientid={client.get('id')}>PDF Teamleden</DownloadTeamMembersButton>
                    </div>
                    <h2>Regelementen</h2>
                    <div>
                        <ul>
                            <li><a href={`${apiUrl}/usc-klachtenreglement.pdf`}>Klachtenreglement</a></li>
                            <li><a href={`${apiUrl}/usc-privacyreglement.pdf`}>Privacyverklaring</a></li>
                            <li><a href={`${apiUrl}/usc-algemene-voorwaarden.pdf`}>Algemene voorwaarden</a></li>
                        </ul>
                    </div>
                </div>

                <div className="client-view-content">
                
                    <Switch>
                        <Route path={`${path}/teamcontact`} render={(props) => <SingleClientTeamContact client={client} />} />
                        <Route path={`${path}/documents`} render={() => <SingleClientDocuments clientportal={clientportal} client={client} />} />
                        <Route path={`${path}`} render={props => <SingeClientPlanning client={client} profileplanning={profileplanning} />} />
                        
                        
                    </Switch>


                </div>


            </div>

            
            

        </div>


    }

}

export default connect(mapStateToProps, mapDispatchToProps)(SingleClient);


function DownloadTeamMembersButton({ freelancers, clientid, children, client }) {

    const clientportal = useSelector(state => state.getIn(['users','single','clientportal', 0], Map()) || Map());

    const download = async () => {

        let form = new FormData();

        let fileString = PdfService.renderToStatic(
            <TeamMembersPrint clientportal={clientportal} freelancers={freelancers} client={client} />);
        let filename = `teamleden-${clientid}.pdf`

        form.append('html',
            fileString
        );

        form.append('settings[printBackground]', true);
        form.append('settings[displayHeaderFooter]', false);
        form.append('settings[preferCSSPageSize]', true);
        form.append('settings[width]', "210mm");
        form.append('settings[height]', "297mm");

        form.append('settings[headerTemplate]', "<div></div>");
        form.append('settings[footerTemplate]', '<div style="width:100%;color:black;font-size:12px;font-family:arial;text-align:right;padding-right:12.5mm">Pagina <span class="pageNumber"></span> van <span class="totalPages"></span></div>');

        form.append('settings[margin][top]', "0mm");
        form.append('settings[margin][bottom]', "0mm");
        form.append('settings[margin][left]', "0mm");
        form.append('settings[margin][right]', "0mm");

        form.append('filename', filename);

        let accessToken = await authenticationService.getAccessToken();



        var xhr = new XMLHttpRequest();
        xhr.withCredentials = true;
        xhr.open("POST", `${apiUrl}/v4/services/generate-pdf`, true);
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        xhr.setRequestHeader("Authorization", `Bearer ${accessToken}`);
        xhr.responseType = 'blob';
        xhr.send(   (new URLSearchParams(form)).toString()  );
        xhr.onload = function(e) {
            if(this.status == 200) {
                console.log("hmm", this);
                var blob = this.response;
                let a = document.createElement("a");
                a.style = "display: none";
                document.body.appendChild(a);
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }
        }

    }

    return <a href="javascript:;" onClick={download}>{children}</a>

}

//  <link rel="stylesheet" media="all" type="text/css" href="https://app2.u-staat-centraal.nl/style/pbookingoverview.css" />
function TeamMembersPrint({ freelancers, client, clientportal }) {

    let aanhef = 'Mw.';
    if(client.get('gender') == 'M' || client.get('gender') == 'm') {
        aanhef = "Dhr.";
    }

    return <html>
        <head>
            { <base href={`https://clientportal.zorgconnect.u-staat-centraal.nl`} /> }
           <link rel="stylesheet" media="print" type="text/css" href={`/print/style.css`} /> 
           <link rel="stylesheet" media="print" type="text/css" href={`/print/team-members.css`} />
        </head>
        <body>
            <div className="team-member-page page-container">
                <table className="page-table">
                    <thead>
                        <tr>
                            <td>
                                <div className="page-header-space">
                                    <h1>Teamleden van {aanhef} {generateDisplayName(client)}</h1>
                                </div>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <div className="page">
                                    <div className="page-footer"><span className="page-numbers">[[page]] van [[pages]]</span></div>
                                    <div className="page-content">

                                        {freelancers && (() => {

                                            let elements = freelancers.map((freelancer, freelancerid) => {
                                                
                                                let aanhef = 'Mw.';
                                                if(freelancer.get('gender') == 'M' || freelancer.get('gender') == 'm') {
                                                    aanhef = "Dhr.";
                                                }

                                                let number = "";
                                                if(freelancer.getIn(['phonenumbers', 0, 'number'])) {
                                                    number = <div>Telefoon: {freelancer.getIn(['phonenumbers', 0, 'number'])}</div>;
                                                }

                                                return <div key={freelancerid}>
                                                    <img src={"PRIVATE_ASSETS_PATH/freelancers/" + freelancer.getIn(['socialDetails','picture'])} />
                                                    <h2>{aanhef} {generateInformalDisplayName(freelancer)} ({freelancer.get('id')})</h2>
                                                    {number}
                                                </div>     
                                            }).toList().toJS();
                                            
                                            let grids = [];
                                            let counter = 0;
                                            while(elements.length > 0) {
                                                if(counter % 4 == 0) {
                                                    grids.push([]);
                                                }
                                                let element = elements.shift();
                                                grids[grids.length - 1].push(element);
                                                counter++;
                                            }
                                        
                                            return grids.map((grid, index) => <div className="freelancers" key={index.toString()}>{grid}</div>)


                                        })()}

                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot><tr><td><div className="page-footer-space "></div></td></tr></tfoot>
                </table>
            </div>
        </body>
    </html>
            

}